import { INSIGHT_REPORTS } from './author/Reports/common/constants/standard-reports'

export const s3ImageBucketPath =
  process.env.REACT_APP_S3_IMAGE_PATH || 'https://edureact-dev.s3.amazonaws.com'

/*
Districts having QTI IMPORT ACCESS
1,2 - POC DISTRICT IDS FOR Barra USD & Corio District
3,4 - PROD DISTRICT IDS FOR Barra USD & Corio District
5 - DRY RUN / SANDBOX DISTRICT ID
*/
export const QTI_DISTRICTS = [
  '5e79ae5eda6952de6c21e279',
  '5ebc2adfda6952de6ce9ffb7',
  '5e3d194d03b7ad09241ce6d6',
  '5ebbbb3b03b7ad0924d19c46',
  '5dce67dac9607d00070ad888',
]

export const GCPS_DISTRICT_IDS =
  process.env.REACT_APP_GCPS_DISTRICT_IDS ||
  '635918f1559a0f00082f0694,631f286ca526d5198f1eba80'

export const GCPS_DEMO_USER_IDS = (
  process.env.REACT_APP_GCPS_DEMO_USER_IDS || ''
)
  .trim()
  .split(',')
  .map((id) => id.trim())
  .filter((id) => !!id)

export const GOOGLE_APP_ID = process.env.REACT_APP_GOOGLE_APP_ID
export const BASE_TITLE = 'Pear Assessment'
export const DEFAULT_PAGE_TITLE =
  'Pear Assessment: Formative and Summative Assessments Made Easy'
const BASE_TITLE_FOR_ADMIN_SETTINGS =
  'Pear Assessment: Formative and Summative Assessments Made Easy'

const getRoutePageTitles = (routes, suffix = `${BASE_TITLE}`) =>
  Object.entries(routes).reduce(
    (acc, [route, title]) => ({
      ...acc,
      [route]: `${title} - ${suffix}`,
    }),
    {}
  )

const DISTRICT_ADMIN_SETTINGS_ROUTES = {
  '/author/districtprofile': 'District Profile Setting',
  '/author/schools': 'School Setting',
  '/author/users': 'Users Setting',
  '/author/groups': 'Groups Setting',
  '/author/content': 'Content Setting',
  '/author/settings': 'Settings',
  '/author/classes': 'Classes Setting',
  '/author/courses': 'Courses Setting',
  '/author/class-enrollment': 'Class Enrollment Setting',
  '/author/content/collections': 'Content Collections Setting',
  '/author/content/buckets': 'Content Buckets Setting',
  '/author/content/tools': 'Content Tools Setting',
}

const REPORT_ROUTES = INSIGHT_REPORTS.reduce((acc, reportCategory) => {
  reportCategory.cards.forEach((card) => {
    if (
      typeof card === 'object' &&
      card !== null &&
      card.location &&
      card.title
    ) {
      // just a precautionary check so we it doesn't break accidentally in future because of ds change
      acc[card.location] = `${card.title} Report`
    }
  })
  return acc
}, {})

export const ROUTE_PAGE_TITLES = {
  ...getRoutePageTitles(REPORT_ROUTES),
  ...getRoutePageTitles(
    DISTRICT_ADMIN_SETTINGS_ROUTES,
    BASE_TITLE_FOR_ADMIN_SETTINGS
  ),
}

const STUDENT_ROUTES = {
  '/home/assignments': 'Assignments',
  '/home/grades': 'Grades',
  '/home/skill-mastery': 'Skill Mastery',
  '/home/manage': 'Manage Class',
  '/home/profile': 'My Profile',
}

const TEST_ROUTES = {
  '/author/tests/select': 'Select Test',
  '/author/tests/create/addItems': 'Add Test Items',
  '/author/tests/create/description': 'Add Test Description',
  '/author/tests/create/review': 'Review Test',
  '/author/tests/create/settings': 'Test Settings',
  '/author/tests/tab/description': 'Add Test Description',
  '/author/tests/tab/addItems': 'Add Test Items',
  '/author/tests/tab/review': 'Review Test',
  '/author/tests/tab/settings': 'Test Settings',
}

export const TEST_ROUTE_PAGE_TITLES = getRoutePageTitles(TEST_ROUTES)

export const STUDENT_ROUTE_PAGE_TITLES = getRoutePageTitles(STUDENT_ROUTES)

export const AUTHOR_ROUTE_PAGE_TITLES = {
  '/author/assignments':
    'Assignment - Pear Assessment: Formative and Summative Assessments Made Easy',
}
